import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

class WhitelabelService {
  // Lazy getter: createAxiosInstance is NOT called at module-load time.
  // Calling it in the constructor caused a TDZ crash in production webpack
  // scope-hoisting builds because the cycle
  //   services/index.js → store/index.js → WhitelabelService.js → services/index.js
  // caused webpack to place WhitelabelService module code before the
  // `const createAxiosInstance` assignment in the concatenated scope.
  // By deferring to first use (always after full module initialisation),
  // the const is guaranteed to be initialized.
  get client() {
    if (!this._client) {
      const baseUrl =
        process.env.VUE_APP_WHITELABEL_URL ?? `${hostConfig.apiBaseUrl}/whitelabel-service`;
      this._client = createAxiosInstance(baseUrl, 5000);
    }
    return this._client;
  }

  async fetchConfig(domain) {
    return this.client.get(`/v3/whitelabel/domain/${encodeURIComponent(domain)}`, {
      silent: true,
    });
  }
}

// Export the CLASS, not an eager singleton.  Instantiating new WhitelabelService()
// at module scope inside a webpack scope-hoisted production bundle can trigger a
// TDZ ReferenceError for `createAxiosInstance` because the circular-import chain
//   services/index.js → store/index.js → WhitelabelService.js → services/index.js
// causes webpack to place this module before the `const createAxiosInstance`
// definition in the concatenated scope.  The store lazily creates the one instance
// it needs via getWhitelabelSvc() (see store/index.js), so no singleton lives at
// module-load time.
export default WhitelabelService;
